import { render, staticRenderFns } from "./Loud.vue?vue&type=template&id=a8c93796&scoped=true&"
import script from "./Loud.vue?vue&type=script&lang=js&"
export * from "./Loud.vue?vue&type=script&lang=js&"
import style0 from "./Loud.vue?vue&type=style&index=0&id=a8c93796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c93796",
  null
  
)

export default component.exports